/*
 * Author M. Atoar Rahman
 * Title: Facility Current Stock
 * Description: Page for Facility Current Stock
 * Date: 13/07/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { CurrentStockProvider } from '../facility/currentStock/ContextAPI';
import Index from '../facility/currentStock/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityCurrentStock() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-current-stock']) return <PermissionDenied />;

    return (
        <CurrentStockProvider>
            <Index />
        </CurrentStockProvider>
    );
}
